import { render, staticRenderFns } from "./PayInTest.vue?vue&type=template&id=9dcc2096&scoped=true"
import script from "./PayInTest.vue?vue&type=script&lang=js"
export * from "./PayInTest.vue?vue&type=script&lang=js"
import style0 from "./PayInTest.vue?vue&type=style&index=0&id=9dcc2096&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcc2096",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dcc2096')) {
      api.createRecord('9dcc2096', component.options)
    } else {
      api.reload('9dcc2096', component.options)
    }
    module.hot.accept("./PayInTest.vue?vue&type=template&id=9dcc2096&scoped=true", function () {
      api.rerender('9dcc2096', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/api/components/PayInTest.vue"
export default component.exports